const errors = {
  9001: 'A scheduled payment is linked to that payment method.',
};

export default errors;
